import {
  LOGIN_CLEAR,
  LOGIN_CLEAR_ERROR,
  LOGIN_START,
  LOGIN_ERROR,
  LOGIN_REQUIRE_MFA,
  LOGIN_USER_INFO
} from '../constants/actionTypes'

export const initialState = {
  done: true,
  requireMFA: false,
  errorAuth: '',
  errorOther: '',
  userInfo: undefined
}

const loginClear = clearedState => clearedState

const loginClearError = state => ({ ...state, errorAuth: '', errorOther: '', userInfo: undefined })

const loginStart = state => ({ ...state, done: false, userInfo: undefined })

const loginRequireMFA = state => ({ ...state, done: true, requireMFA: true, userInfo: undefined })

const loginError = (state, action) => ({
  ...state,
  done: true,
  requireMFA: false,
  errorAuth: action.payload.errorAuth,
  errorOther: action.payload.errorOther,
  needsName: false,
  needsPhone: false,
  userInfo: undefined
})

const loginUserInfo = (state, action) => ({
  ...state,
  userInfo: action.payload.userInfo
})

export const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_CLEAR: return loginClear(initialState)
    case LOGIN_CLEAR_ERROR: return loginClearError(state)
    case LOGIN_START: return loginStart(state)
    case LOGIN_REQUIRE_MFA: return loginRequireMFA(state)
    case LOGIN_ERROR: return loginError(state, action)
    case LOGIN_USER_INFO: return loginUserInfo(state, action)
    default: return state
  }
}
